﻿import { Patient, User } from '.';

export class Aidant {
    id: number;
    phonePrefix: string;
    phone: string;
    role: string;
    key: string;
    tempName: string;
    associated: boolean;
    enabled: boolean;
    patient: Patient;
    user: User;

    constructor(json: any) {
        this.id = json.id;
        this.phonePrefix = json.phonePrefix;
        this.phone = json.phone;
        this.role = json.role;
        this.key = json.key;
        this.tempName = json.tempName;
        this.associated = json.associated;
        this.enabled = json.enabled;
        this.patient = json.patient;
        this.user = json.user;
    }

    generateKey() {
        this.key = Math.random().toString().slice(2, 12);
    }
}
